import producer from 'immer';
import { FETCH_PAYMENTS } from './types';
import { addPaymentsToState } from './handlers/paymentsHandler';

export const initialState = {
  bills: [],
  invoiceIssuanceDetails: null,
  hasFetchedPayments: false,
  isLoadingPayments: false,
  showPaymentsListError: false,
};

export const paymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENTS:
      return addPaymentsToState(state, action);
    default:
      return state;
  }
};

export default producer(paymentsReducer);
